<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="1343"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="min-height:650px;">
									<!-- 标题和筛选 -->
									<div class="board_title">
									<div class="title-left">
										<h3>任务大厅</h3>
										<p class="subtitle">查看和管理任务</p>
									</div>
									<div class="title-right">
										<el-select
											v-model="searchData.status"
											placeholder="任务状态"
											size="small"
											style="width:120px;margin-right:10px"
											@change="handleSearch"
											clearable
										>
											<el-option label="待开始" value="pending"></el-option>
											<el-option label="进行中" value="in_progress"></el-option>
											<el-option label="已完成" value="completed"></el-option>
											<el-option label="已过期" value="expired"></el-option>
										</el-select>
										<el-select
											v-model="searchData.group_id"
											placeholder="任务分组"
											size="small"
											style="width:150px;margin-right:10px"
											@change="handleSearch"
											clearable
										>
											<el-option
												v-for="group in groupList"
												:key="group.group_id"
												:label="group.group_name"
												:value="group.group_id"
											></el-option>
										</el-select>
										<el-select
											v-model="searchData.mer_shop_id"
											placeholder="全部店铺"
											size="small"
											style="width:180px"
											@change="handleShopChange"
											filterable
											clearable
										>
											<el-option
												v-for="shop in shopList"
												:key="shop.mer_shop_id || shop.id"
												:label="shop.shop_name"
												:value="shop.mer_shop_id || shop.id"
											></el-option>
										</el-select>
									</div>
								</div>

								<!-- 任务统计 -->
								<div class="task-stats">
									<div class="stat-item">
										<div class="stat-value">{{ stats.total }}</div>
										<div class="stat-label">总任务数</div>
									</div>
									<div class="stat-item">
										<div class="stat-value">{{ stats.pending }}</div>
										<div class="stat-label">待开始</div>
									</div>
									<div class="stat-item">
										<div class="stat-value">{{ stats.in_progress }}</div>
										<div class="stat-label">进行中</div>
									</div>
									<div class="stat-item highlight">
										<div class="stat-value">{{ stats.completed }}</div>
										<div class="stat-label">已完成</div>
									</div>
								</div>

								<!-- 任务列表 -->
								<el-table
									:data="taskList"
									v-loading="loading"
									border
									style="width:100%;margin-top:15px;">
									<el-table-column align="left" prop="task_name" label="任务名称" min-width="200">
										<template slot-scope="scope">
											<div class="task-name-cell">
												<div class="task-title">{{ scope.row.task_name }}</div>
												<div class="task-group">{{ scope.row.group_name }}</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column align="left" prop="shop_name" label="店铺名称" width="150"></el-table-column>
									<el-table-column align="center" prop="status" label="状态" width="90">
										<template slot-scope="scope">
											<span class="task-status" :class="scope.row.status">
												{{ getStatusText(scope.row.status) }}
											</span>
										</template>
									</el-table-column>
									<el-table-column align="center" label="操作" width="180" fixed="right">
										<template slot-scope="scope">
											<el-button type="text" size="small" @click="goToDetail(scope.row)">查看详情</el-button>
											<el-button
												v-if="scope.row.status === 'in_progress'"
												type="text"
												size="small"
												@click="showCompleteTaskDialog(scope.row)"
												style="color:#67c23a"
											>
												完成任务
											</el-button>
										</template>
									</el-table-column>
								</el-table>

								<!-- 分页 -->
								<div class="turn_page" v-if="taskList.length > 0">
									<el-pagination
										@current-change="handlePageChange"
										:current-page="page"
										:page-size="limit"
										layout="total, prev, pager, next"
										:total="total">
									</el-pagination>
								</div>

								<!-- 空状态 -->
								<div v-if="!loading && taskList.length === 0" class="empty">
									<p>暂无可用任务</p>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>

		<!-- 完成任务弹窗 -->
			<el-dialog title="完成任务"
			:visible.sync="showCompleteDialog"
			width="600px"
			@close="onCompleteDialogClose"
		>
			<div v-if="currentTask" class="complete-dialog-content">
				<div class="task-info">
					<h3>{{ currentTask.task_name }}</h3>
					<p class="task-desc">{{ currentTask.task_description }}</p>
				</div>

				<div class="operation-steps" v-if="currentTask.operation_steps">
					<h4>操作步骤：</h4>
					<div class="steps-content" v-html="currentTask.operation_steps"></div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showCompleteDialog = false">取消</el-button>
				<el-button
					type="primary"
					@click="confirmComplete"
				>
					已完成
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import myHead from '@/components/myHead/myhead.vue'
import myFoot from '@/components/myFoot/myfoot.vue'
import ucMenu from '@/components/ucenterMenu/ucmenu.vue'
import { getMyTasks, getTaskStats, completeTask } from '@/api/main/task'
import { mapActions } from 'vuex'

export default {
	name: 'TaskHall',
	components: {
		myHead,
		myFoot,
		ucMenu
	},
	data() {
		return {
			loading: false,
			taskList: [],
			groupList: [],
			shopList: [],
			searchData: {
				mer_shop_id: null,
				group_id: null,
				status: null
			},
			stats: {
				total: 0,
				pending: 0,
				in_progress: 0,
				completed: 0,
				expired: 0,
				total_points: 0
			},
			page: 1,
			limit: 20,
			total: 0,
			progressColor: '#f0413e',
			showCompleteDialog: false,
			currentTask: null
		}
	},
	mounted() {
		// 显示功能开发中提示
		this.$alert('该功能正在开发中，敬请期待！', '提示', {
			confirmButtonText: '我知道了',
			type: 'info',
			center: true
		})

		this.loadShopList()
		this.loadGroupList()
	},
	methods: {
		...mapActions({
			getShopList: 'shop_board/getShopList'
		}),
		// 加载店铺列表
		loadShopList() {
			this.getShopList({
				data: {},
				success: (res) => {
					if (res.code === 200 && res.data) {
						// 处理不同的数据结构
						let shopList = []
						if (res.data.list && res.data.list.list) {
							shopList = res.data.list.list
						} else if (Array.isArray(res.data.list)) {
							shopList = res.data.list
						} else if (Array.isArray(res.data)) {
							shopList = res.data
						}

						// 确保每个店铺都有 mer_shop_id 字段
						this.shopList = shopList.map(shop => {
							// 如果没有 mer_shop_id，尝试使用其他可能的字段名
							if (!shop.mer_shop_id && shop.id) {
								shop.mer_shop_id = shop.id
							}
							return shop
						})

						console.log('店铺列表加载成功:', this.shopList)

						// 加载数据
						this.loadData()
						this.loadStats()
					}
				}
			})
		},
		// 加载任务分组列表
		async loadGroupList() {
			// 这里可以添加获取分组列表的接口
			// 暂时使用硬编码
			this.groupList = [
				{ group_id: 1, group_name: '新手任务' },
				{ group_id: 2, group_name: '日常任务' },
				{ group_id: 3, group_name: '成长任务' }
			]
		},
		// 筛选
		handleSearch() {
			console.log('筛选触发，当前筛选条件:', this.searchData)
			this.page = 1
			this.loadData()
			this.loadStats()
		},
		// 店铺筛选
		handleShopChange(value) {
			console.log('店铺筛选变化:', value)
			this.handleSearch()
		},
		// 分页
		handlePageChange(page) {
			this.page = page
			this.loadData()
		},
		// 加载任务列表
		async loadData() {
			this.loading = true
			try {
				const params = {
					page: this.page,
					limit: this.limit
				}

				// 如果选择了状态，传递 status 参数
				if (this.searchData.status) {
					params.status = this.searchData.status
				}

				// 如果选择了店铺，传递 mer_shop_id 参数
				if (this.searchData.mer_shop_id) {
					params.mer_shop_id = this.searchData.mer_shop_id
				}

				// 如果选择了分组，传递 group_id 参数
				if (this.searchData.group_id) {
					params.group_id = this.searchData.group_id
				}

				console.log('加载任务列表，参数:', params)

				const res = await getMyTasks(params)
				if (res.code === 200) {
					this.taskList = res.data.list || []
					this.total = res.data.total || 0
					console.log('任务列表加载成功:', this.taskList.length, '条')
				}
			} catch (error) {
				console.error('加载任务失败:', error)
				this.$message.error('加载任务失败')
			} finally {
				this.loading = false
			}
		},
		// 加载统计
		async loadStats() {
			try {
				const params = {}
				// 如果选择了店铺，传递 mer_shop_id 参数
				if (this.searchData.mer_shop_id) {
					params.mer_shop_id = this.searchData.mer_shop_id
				}
				const res = await getTaskStats(params)
				if (res.code === 200) {
					this.stats = res.data
				}
			} catch (error) {
				console.error('加载统计失败:', error)
			}
		},
		// 查看详情
		goToDetail(task) {
			this.$router.push({
				path: '/uc_task_detail',
				query: { task_id: task.task_id, menuId: 1343 }
			})
		},
		// 显示完成任务弹窗
		showCompleteTaskDialog(task) {
			this.currentTask = task
			this.showCompleteDialog = true
		},
		// 关闭弹窗
		onCompleteDialogClose() {
			this.currentTask = null
		},
		// 确认完成任务
		async confirmComplete() {
			if (!this.currentTask) return

			try {
				const res = await completeTask({ task_id: this.currentTask.task_id })
				if (res.code === 200) {
					this.$message.success('任务已完成')
					this.showCompleteDialog = false
					this.currentTask = null
					this.loadData()
					this.loadStats()
				} else {
					this.$message.error(res.msg || res.message || '完成任务失败')
				}
			} catch (error) {
				console.error('完成任务失败:', error)
				this.$message.error('完成任务失败')
			}
		},
		// 格式化触发条件
		formatTriggerCondition(task) {
			const conditions = task.conditions || {}
			const type = conditions.type || task.trigger_type

			const typeMap = {
				shop_score: '店铺体验分',
				sales_amount: '销售额',
				order_count: '订单数',
				product_count: '商品数',
				manual: '手动完成'
			}

			const typeName = typeMap[type] || type

			if (conditions.target_value) {
				return `${typeName} ≥ ${conditions.target_value}`
			}

			return typeName
		},
		// 状态文本
		getStatusText(status) {
			const statusMap = {
				pending: '待开始',
				in_progress: '进行中',
				completed: '已完成',
				expired: '已过期'
			}
			return statusMap[status] || status
		}
	}
}
</script>

<style scoped>
/* 基础布局 */

.center{display: flex;flex: 1;}

.el-card__body{padding:12px 20px;}

/* 标题样式 */
.board_title {
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #eee;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.title-left h3 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 5px;
	color: #333;
}

.title-left .subtitle {
	color: #999;
	font-size: 13px;
	margin: 0;
}

/* 任务统计 */
.task-stats {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 15px;
	margin-bottom: 20px;
}

.stat-item {
	background: #f8f9fa;
	padding: 20px;
	border-radius: 6px;
	text-align: center;
	border: 1px solid #e8e8e8;
}

.stat-item.highlight {
	background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
	color: #fff;
	border-color: #67c23a;
}

.stat-value {
	font-size: 28px;
	font-weight: 600;
	margin-bottom: 8px;
}

.stat-label {
	font-size: 13px;
	opacity: 0.8;
}

/* 任务名称单元格 */
.task-name-cell {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.task-title {
	font-size: 14px;
	font-weight: 600;
	color: #333;
}

.task-group {
	font-size: 12px;
	color: #999;
}

/* 触发条件 */
.trigger-text {
	font-size: 13px;
	color: #666;
}

/* 奖励积分 */
.reward-points {
	color: #fa8c16;
	font-weight: 600;
	font-size: 14px;
}

/* 任务状态 */
.task-status {
	padding: 3px 10px;
	border-radius: 10px;
	font-size: 12px;
	white-space: nowrap;
}

.task-status.pending {
	background: #e8f4ff;
	color: #1890ff;
}

.task-status.in_progress {
	background: #fff7e6;
	color: #fa8c16;
}

.task-status.completed {
	background: #f6ffed;
	color: #52c41a;
}

.task-status.expired {
	background: #fff1f0;
	color: #ff4d4f;
}

/* 分页 */
.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 15px;
}

/* 空状态 */
.empty {
	text-align: center;
	padding: 60px 20px;
	color: #999;
	font-size: 14px;
}

/* 完成任务弹窗 */
.complete-dialog-content {
	padding: 10px 0;
}

.task-info h3 {
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin-bottom: 10px;
}

.task-desc {
	font-size: 14px;
	color: #666;
	line-height: 1.6;
	margin-bottom: 20px;
}

.operation-steps {
	background: #f8f9fa;
	border-radius: 6px;
	padding: 15px;
	margin-bottom: 20px;
}

.operation-steps h4 {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	margin-bottom: 10px;
}

.steps-content {
	font-size: 14px;
	color: #666;
	line-height: 1.8;
}

.steps-content :deep(ol),
.steps-content :deep(ul) {
	padding-left: 20px;
	margin: 10px 0;
}

.steps-content :deep(li) {
	margin: 8px 0;
}

</style>
